{
  "import": "Import Content Pack",
  "create": "Create Content Pack",
  "form": {
    "name": "Name",
    "version": "Version",
    "description": "Description",
    "monitoring_templates": "Monitoring Templates",
    "monitoring_jobs": "Monitoring Jobs",
    "monitoring_hits": "Monitoring Hits",
    "monitoring_exporters": "Monitoring Exporters",
    "enrichment_plans": "Enrichment Plans",
    "dashboards": "Dashboards",
    "attributes": "Attributes",
    "ci_types": "CI Types",
    "monitoring_vmagents": "VM Agents",
    "monitoring_vmalerts": "VM Alerts"
  }
}